import React, { useEffect, useState } from "react";
import {
  FiAlertCircle,
  FiCheckCircle,
  FiClock,
  FiLink,
  FiMessageCircle,
  FiRefreshCw,
  FiSettings,
  FiUsers,
} from "react-icons/fi";
import api from "../../utills/api";
import {
  Card,
  Col,
  CardHeader,
  Row,
 
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
const INITIAL = {
  connected: false,
  connectionStatus: "Not Connected",
  businessName: "",
  phoneNumber: "",
  phoneNumberId: "",
  businessAccountId: "",
  messagesSent: 0,
  messagesReceived: 0,
  lastSyncAt: null,
  lastError: "",
};

const WhatsApp = () => {
  const [integration, setIntegration] =
    useState(INITIAL);
  const [form, setForm] = useState({
    businessAccountId: "",
    phoneNumberId: "",
    displayPhoneNumber: "",
    verifiedName: "",
    accessToken: "",
  });
  const [loading, setLoading] =
    useState(true);
  const [actionLoading, setActionLoading] =
    useState(false);
  const [message, setMessage] =
    useState("");
  const [error, setError] =
    useState("");

  const loadIntegration = async () => {
    try {
      setLoading(true);
      setError("");

      const response =
        await api.get(
          "/whatsapp/status"
        );

      const data =
        response?.data?.data || {};

      const saved =
        data?.integration || {};

      setIntegration({
        connected:
          Boolean(data.connected),
        connectionStatus:
          saved.connectionStatus ||
          "Not Connected",
        businessName:
          saved.verifiedName || "",
        phoneNumber:
          saved.displayPhoneNumber || "",
        phoneNumberId:
          saved.phoneNumberId || "",
        businessAccountId:
          saved.businessAccountId || "",
        messagesSent:
          Number(
            saved.messagesSent || 0
          ),
        messagesReceived:
          Number(
            saved.messagesReceived || 0
          ),
        lastSyncAt:
          saved.lastSyncAt || null,
        lastError:
          saved.lastError || "",
      });

      if (saved.businessAccountId) {
        setForm((previous) => ({
          ...previous,
          businessAccountId:
            saved.businessAccountId,
        }));
      }

      if (saved.phoneNumberId) {
        setForm((previous) => ({
          ...previous,
          phoneNumberId:
            saved.phoneNumberId,
        }));
      }

      if (saved.displayPhoneNumber) {
        setForm((previous) => ({
          ...previous,
          displayPhoneNumber:
            saved.displayPhoneNumber,
        }));
      }

      if (saved.verifiedName) {
        setForm((previous) => ({
          ...previous,
          verifiedName:
            saved.verifiedName,
        }));
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Unable to load WhatsApp integration."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadIntegration();
  }, []);

  const handleChange = (event) => {
    const {
      name,
      value,
    } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const connect = async (event) => {
    event.preventDefault();

    if (
      !form.businessAccountId ||
      !form.phoneNumberId ||
      !form.accessToken
    ) {
      setError(
        "Business Account ID, Phone Number ID and Access Token are required."
      );
      return;
    }

    try {
      setActionLoading(true);
      setError("");
      setMessage("");

      const response =
        await api.post(
          "/whatsapp/connect",
          {
            businessAccountId:
              form.businessAccountId.trim(),
            phoneNumberId:
              form.phoneNumberId.trim(),
            displayPhoneNumber:
              form.displayPhoneNumber.trim(),
            verifiedName:
              form.verifiedName.trim(),
            accessToken:
              form.accessToken.trim(),
          }
        );

      setMessage(
        response?.data?.message ||
          "WhatsApp connected successfully."
      );

      setForm((previous) => ({
        ...previous,
        accessToken: "",
      }));

      await loadIntegration();
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Unable to connect WhatsApp."
      );
    } finally {
      setActionLoading(false);
    }
  };

  const disconnect = async () => {
    try {
      setActionLoading(true);
      setError("");
      setMessage("");

      await api.post(
        "/whatsapp/disconnect"
      );

      setMessage(
        "WhatsApp integration disconnected."
      );

      await loadIntegration();
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Unable to disconnect WhatsApp."
      );
    } finally {
      setActionLoading(false);
    }
  };

  const formatDate = (value) => {
    if (!value) return "Never";

    const date = new Date(value);

    return Number.isNaN(date.getTime())
      ? "Never"
      : date.toLocaleString("en-IN", {
          dateStyle: "medium",
          timeStyle: "short",
        });
  };

  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid py-5 text-center">
          <FiRefreshCw
            className="me-2"
            size={20}
          />
          Loading WhatsApp integration...
        </div>
      </div>
    );
  }
document.title =
    "Whatsapp Intigration | eduLeads.Online";
  return (
    <div className="page-content">
      <div className="container-fluid">
              <BreadCrumb
                  title="Whatsapp Intigration"
                  pageTitle="Intigration"
                />

                
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="flex-grow-1">
                    <h5 className="mb-0">
              WhatsApp Integration
                    </h5>

                    <small className="text-muted">
                      Connect WhatsApp Cloud API securely
              for education lead communication.
                    </small>
                  </div>
                 <button
                  type="button"
                  className="btn btn-light"
                  onClick={loadIntegration}
                  disabled={actionLoading}
                >
                  <FiRefreshCw
                    className="me-1"
                    size={16}
                  />
                  Refresh
                </button>
                </div>
               
              </CardHeader>
            </Card>
          </Col>
        </Row>
      

        {error && (
          <div className="alert alert-warning d-flex align-items-start">
            <FiAlertCircle
              size={18}
              className="me-2 mt-1"
            />
            <div>{error}</div>
          </div>
        )}

        {message && (
          <div className="alert alert-success d-flex align-items-start">
            <FiCheckCircle
              size={18}
              className="me-2 mt-1"
            />
            <div>{message}</div>
          </div>
        )}

        <div className="card mb-4">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <div className="avatar-sm me-3">
                  <span className="avatar-title rounded-circle bg-success-subtle text-success fs-20">
                    <FiMessageCircle />
                  </span>
                </div>

                <div>
                  <h5 className="mb-1">
                    WhatsApp Cloud API
                  </h5>
                  <div className="d-flex align-items-center gap-2">
                    {integration.connected ? (
                      <FiCheckCircle
                        size={16}
                        className="text-success"
                      />
                    ) : (
                      <FiClock
                        size={16}
                        className="text-muted"
                      />
                    )}
                    <span>
                      {integration.connectionStatus}
                    </span>
                  </div>
                </div>
              </div>

              {integration.connected && (
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={disconnect}
                  disabled={actionLoading}
                >
                  Disconnect
                </button>
              )}
            </div>
          </div>
        </div>

        {!integration.connected && (
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title mb-0">
                Connect WhatsApp Cloud API
              </h5>
            </div>

            <div className="card-body">
              <div className="alert alert-info">
                The access token is sent directly to the
                backend and is never stored in browser
                localStorage.
              </div>

              <form onSubmit={connect}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      WhatsApp Business Account ID
                    </label>
                    <input
                      className="form-control"
                      name="businessAccountId"
                      value={
                        form.businessAccountId
                      }
                      onChange={handleChange}
                      placeholder="Business Account ID"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Phone Number ID
                    </label>
                    <input
                      className="form-control"
                      name="phoneNumberId"
                      value={
                        form.phoneNumberId
                      }
                      onChange={handleChange}
                      placeholder="Phone Number ID"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Display Phone Number
                    </label>
                    <input
                      className="form-control"
                      name="displayPhoneNumber"
                      value={
                        form.displayPhoneNumber
                      }
                      onChange={handleChange}
                      placeholder="+91..."
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Verified Name
                    </label>
                    <input
                      className="form-control"
                      name="verifiedName"
                      value={
                        form.verifiedName
                      }
                      onChange={handleChange}
                      placeholder="Business display name"
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label">
                      WhatsApp Access Token
                    </label>
                    <textarea
                      className="form-control"
                      name="accessToken"
                      value={
                        form.accessToken
                      }
                      onChange={handleChange}
                      rows={3}
                      placeholder="Paste the Meta WhatsApp Cloud API access token"
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={actionLoading}
                >
                  <FiLink
                    size={15}
                    className="me-1"
                  />
                  {actionLoading
                    ? "Connecting..."
                    : "Connect WhatsApp"}
                </button>
              </form>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-xl-6">
            <div className="card h-100">
              <div className="card-header">
                <h5 className="card-title mb-0">
                  Business Information
                </h5>
              </div>

              <div className="card-body">
                <div className="d-flex align-items-center mb-4">
                  <FiSettings
                    size={22}
                    className="text-primary me-2"
                  />
                  <span className="text-muted">
                    Connected WhatsApp account
                  </span>
                </div>

                <div className="mb-3">
                  <small className="text-muted d-block">
                    Verified Name
                  </small>
                  <strong>
                    {integration.businessName ||
                      "—"}
                  </strong>
                </div>

                <div className="mb-3">
                  <small className="text-muted d-block">
                    Phone Number
                  </small>
                  <strong>
                    {integration.phoneNumber ||
                      "—"}
                  </strong>
                </div>

                <div className="mb-3">
                  <small className="text-muted d-block">
                    Phone Number ID
                  </small>
                  <strong>
                    {integration.phoneNumberId ||
                      "—"}
                  </strong>
                </div>

                <div>
                  <small className="text-muted d-block">
                    Business Account ID
                  </small>
                  <strong>
                    {integration.businessAccountId ||
                      "—"}
                  </strong>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-6">
            <div className="card h-100">
              <div className="card-header">
                <h5 className="card-title mb-0">
                  WhatsApp Lead Communication
                </h5>
              </div>

              <div className="card-body">
                <div className="d-flex align-items-center mb-4">
                  <FiUsers
                    size={22}
                    className="text-success me-2"
                  />
                  <span className="text-muted">
                    Incoming WhatsApp messages are
                    processed by the backend lead
                    service.
                  </span>
                </div>

                <p className="text-muted">
                  Webhook events can create or update
                  education leads, activity records and
                  conversation data.
                </p>

                <div>
                  <small className="text-muted d-block">
                    Last Sync
                  </small>
                  <strong>
                    {formatDate(
                      integration.lastSyncAt
                    )}
                  </strong>
                </div>

                {integration.lastError && (
                  <div className="alert alert-danger mt-4 mb-0">
                    {integration.lastError}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsApp;
